import React from "react";
import { Row, Col } from "antd";
import { Field, reduxForm } from "redux-form";
import { Text, Toggle, Email, Password } from "components/redux-form";
import PropTypes from "prop-types";
import MaterialIcon from "components/common/MaterialIcon";
import validate from "./validate";
import asyncValidate from "./asyncValidate";
import { indexPasswordUsers } from "../../Module";
import { connect } from "react-redux";

@reduxForm({
  form: "personnel-form-user-information",
  destroyOnUnmount: false,
  asyncValidate,
  validate: function (values, props) {
    console.log("sdsdfsdf", values);
    console.log("sdsdfsdf", props);

    return validate(values, {
      min: props.minLength,
      max: props.maxLength,
      isComplexPassword: props.isComplexPassword, // ارسال isComplexPassword به validate
    });
  },
  onSubmitFail: (errors, dispatch, submitError, props) => props.onFailure(),
  onSubmit: (values, dispatch, props) => props.onSuccess(),
})
@connect(
  (state) => ({
    settingPassword: state.Basic.Personnel.settingPassword,
  }),
  {
    indexPasswordUsers,
  }
)
@autobind
export default class User extends React.PureComponent {
  static propTypes = {
    initialize: PropTypes.func,
    user: PropTypes.object,
    minLength: PropTypes.number, // مقدار از بک
    maxLength: PropTypes.number, // مقدار از بک
    isComplexPassword: PropTypes.bool, // مقدار از بک
  };

  static defaultProps = {
    user: {},
  };

  componentDidMount() {
    const { user } = this.props;
    this.props.indexPasswordUsers();
    if (user.id) {
      User._initialize(this.props);
    }
  }

  componentWillReceiveProps(np) {
    if (!app._.isEqual(this.props.user, np.user)) {
      User._initialize(np);
    }
  }

  static _initialize(props) {
    props.initialize({
      personnelId: props.user.profile.personnelId,
      identificationCode: props.user.taInfo.identificationCode,
      nightShift: !!props.user.taInfo.nightShift,
      active: !!props.user.active,
      email: props.user.email,
      endWork: !!props.user.endWork,
      // password: 0,
    });
  }

  render() {
    console.log("settingPassword", this.props.settingPassword);
    const { settingPassword } = this.props;
    return (
      <Row style={{ width: "100%" }}>
        <Col sm={24} md={12} lg={8}>
          <Field
            name="personnelId"
            label={app.translate("routes.home.basic.personnel.Personnel Code")}
            prefix={<MaterialIcon name="numeric" />}
            required
            component={Text}
          />
        </Col>

        <Col sm={24} md={12} lg={8}>
          <Field
            name="identificationCode"
            label={app.translate(
              "routes.home.basic.personnel.Identification Code"
            )}
            prefix={<MaterialIcon name="numeric" />}
            required
            component={Text}
          />
        </Col>

        <Col sm={24} md={12} lg={8}>
          <Field
            name="password"
            required
            label={app.translate("routes.home.basic.personnel.Password")}
            prefix={<MaterialIcon name="keyboard-variant" />}
            component={Password}
            minLength={settingPassword.minLength}
            maxLength={settingPassword.maxLength}
            validate={(value) => {
              const errors = [];
            
              if (!value) {
                errors.push("رمز عبور نمی‌تواند خالی باشد.");
              }
            
              if (value?.length < settingPassword?.minLength) {
                errors.push(`رمز عبور باید حداقل ${settingPassword.minLength} کاراکتر داشته باشد.`);
              }
            
              if (value?.length > settingPassword?.maxLength) {
                errors.push(`رمز عبور نباید بیشتر از ${settingPassword?.maxLength} کاراکتر باشد.`);
              }
            
              if (settingPassword.isComplexPassword) {
                const complexityPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).+$/;
                if (!complexityPattern.test(value)) {
                  errors.push("رمز عبور باید شامل حروف بزرگ، حروف کوچک، اعداد و نمادها باشد.");
                }
              }
            
              return errors.length ? errors : undefined;
            }}
            defaultValue={null}            
          />
        </Col>

        <Col sm={24} md={12} lg={8}>
          <Field
            name="email"
            label={app.translate("routes.home.basic.personnel.Email")}
            component={Email}
          />
        </Col>

        <Col sm={24} md={12} lg={8} xl={4}>
          <Field
            name="nightShift"
            label={app.translate("routes.home.basic.personnel.Night Shift")}
            component={Toggle}
          />
        </Col>

        <Col sm={24} md={12} lg={8} xl={4}>
          <Field
            name="active"
            label={app.translate("routes.home.basic.personnel.active")}
            component={Toggle}
          />
        </Col>

        <Col sm={24} md={12} lg={8} xl={4}>
          <Field
            name="endWork"
            label={app.translate("ترک کار")}
            component={Toggle}
          />
        </Col>
        {/* <Col sm={24} md={12} lg={8} xl={4}>
          <Field
            name="changePasswordOnFirstLogin"
            label={app.translate("الزامی شدن تغییر رمز عبور")}
            component={Toggle}
          />
        </Col> */}
      </Row>
    );
  }
}
